import { render, staticRenderFns } from "./hsiiMessages.vue?vue&type=template&id=67b40b25"
import script from "./hsiiMessages.vue?vue&type=script&lang=js"
export * from "./hsiiMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports